module.exports = __webpack_public_path__ + "videos/main_video_1.ce36685.mp4";